<template>
  <section class="collaborate_celebrity_sec">
    <div>
      <div class="collaborate_celebrity_content">
        <p class="colloborte_celebrity_text" v-html="shopifyData.Collaborationtext" />
      </div>
      <div class="collaborte_celebrity_img_grid">
        <div class="link_wrapper">
          <img
            v-lazy="shopifyData.CelebrityleftImg.src"
            :src-placeholder="shopifyData.CelebrityleftImg.placeholder"
            :alt="shopifyData.CelebrityleftImg.alt || 'Left Image'"
            loading="lazy"
            aria-hidden="true"
            aria-label="Left Image"
            width=""
            height=""
            @click="showCard"
          />
          <div class="product_card_wrapper modify-slider">
            <swiper
              :class="{ active: isactive.includes(key) }"
              :modules="modules"
              :slides-per-view="'1'"
              :mousewheel="{ invert: false, releaseOnEdges: true }"
              :navigation="true"
            >
              <swiper-slide v-for="(product, index) in shopifyData.productData" :key="index">
                <productPopup :product-data="product" @close="toggle_selection_for(key)" />
              </swiper-slide>
            </swiper>
          </div>
        </div>
        <div class="link_wrapper">
          <img
            v-lazy="shopifyData.CelebrityrightImg.src"
            :src-placeholder="shopifyData.CelebrityrightImg.placeholder"
            :alt="shopifyData.CelebrityrightImg.alt || 'Right Image'"
            loading="lazy"
            aria-hidden="true"
            aria-label="Right Image"
            width=""
            height=""
            @click="showCard"
          />
          <div class="product_card_wrapper modify-slider">
            <swiper
              :class="{ active: isactive.includes(key) }"
              :modules="modules"
              :slides-per-view="'1'"
              :mousewheel="{ invert: false, releaseOnEdges: true }"
              :navigation="true"
            >
              <swiper-slide v-for="(product, index) in shopifyData.productData2" :key="index">
                <productPopup :product-data="product" @close="toggle_selection_for(key)" />
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// Producct Popup Component Import
import productPopup from '../product-popup.vue';
// Slider Import
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Autoplay, EffectFade } from 'swiper';
import 'swiper/css';
export default {
  components: {
    productPopup,
    Swiper,
    SwiperSlide,
  },

  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {
      modules: [Navigation, Autoplay, EffectFade],
    };
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      isactive: [],
    };
  },
  methods: {
    toggle_selection_for(key) {
      if (window.innerWidth <= 768) {
        if (this.isactive.includes(key)) {
          this.isactive = this.isactive.filter((item) => item !== key);
        } else {
          this.isactive.push(key);
        }
      }
    },
    showCard(e) {
      if (window.innerWidth <= 768) {
        e.target.nextElementSibling.classList.add('show');
      }
    },
  },
};
</script>

<style scoped>
.product_info_card {
  position: static;
  transform: unset;
}

.collaborate_celebrity_content {
  max-width: 50%;
  width: 100%;
  margin: 100px auto;
}
.colloborte_celebrity_text {
  line-height: 16px;
  white-space: pre-wrap;
  font-family: 'adobe-caslon-pro', sans-serif;
  font-size: 14px;
  margin-bottom: 15px;
}
.collaborte_celebrity_img_grid {
  display: flex;
  gap: 10px;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 80%;
  width: 100%;
}
.collaborte_celebrity_img_grid img {
  display: block;
}
.collaborte_celebrity_img_grid a {
  width: calc(50% - 15px);
}

@media only screen and (max-width: 768px) {
  .collaborte_celebrity_img_grid {
    flex-direction: column;
  }
  .collaborte_celebrity_img_grid a {
    width: 100%;
  }
}
</style>
